import { initialState } from './index';

const AppReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DARK_MODE':
      return {
        ...state,
        darkMode: action.payload,
      };
    case 'SET_ZOOM':
      return {
        ...state,
        zoom: action.payload,
      };
    case 'SET_TOKEN_CREDENTIALS':
      return {
        ...state,
        tokenCredentials: action.payload,
      };
    case 'SET_SIM_STATE':
      return {
        ...state,
        simStates: action.payload,
      };
    case 'SET_AUTO_REFRESH':
      return {
        ...state,
        useAutoRefresh: action.payload,
      };
    case 'SET_IS_DEV':
      return {
        ...state,
        isDev: action.payload,
      };
    case 'RESET_APP_STATE':
      return { ...initialState };
    default:
      return state;
  }
};

export default AppReducer;
